<template>
  <div class="container">
    <div class="section1 animate-route" >
      <div class="imgWrapper" id="imgWrapper" v-if="isShowImg">
        <div class="contwrapper">
          <div class="img" id="img">
            <!-- <img alt="xxx" :src="url" style="width: 100%;display:block;" /> -->
          </div>
        </div>
      </div>
      <div class="videoWrap" id="videoWrap">
        <div class="contwrapper">
          <video class="video" id="video" muted autoplay="autoplay" loop="loop" controls="controls">
            <source :src="contentVideo" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="content" id="titleCont">
        <div class="title">{{title}}</div>
        <div class="text" v-html="text"></div>
      </div>
      <div class="nav-wrap" id="nav-wrap">
        <div class="nav-contain clickStyle">
          <div
            class="item"
            v-for="(item,i) in subItem.content"
            :key="i"
            @click="changeContent(item,i)"
            :id="setItemId(i)"
          >
            <div class="box">{{item.navTitle}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
  </div>
</template>

<script>
import {
  getBrowserWidth,
  getBrowserHight,
  getStringSize,
  getBrowserType,
} from "../../../components/js/screen";
export default {
  props: ["data", "pageTitleIndex", "pageIndex"],
  name: "page",
  components: {},
  data() {
    return {
      url: "https://www.csvw.com/u/cms/www/202008/03162427GbYU_700_410.jpg",
      contentVideo: "https://www.csvw.com/u/cms/www/202008/181017385hSs.mp4",
      text: "",
      title: "",
      menuIndex: this.pageTitleIndex, // 一级菜单
      itemIndex: this.pageIndex, // 二级菜单
      menu: this.data.menu,
      menuItem: [], //一级菜单
      subItem: [], // 二级菜单
      isShowImg:true,
    };
  },
  mounted: function () {
    this.makeData();
    const item = this.subItem.content[0];
    this.makeCss();
    setTimeout(() => {
      this.changeContent(item, 0);
    }, 10);
    // 浏览器改变大小监听事件
    // window.onresize = this.changeUrl;
  },
  updated: function () {},
  watch: {
    pageIndex: {
      handler(newValue, oldValue) {
        this.itemIndex = newValue;
        this.updateData();
      },
      deep: true,
    },
    pageTitleIndex: {
      handler(newValue, oldValue) {
        this.menuIndex = newValue;
        this.updateData();
      },
      deep: true,
    },
  },
  methods: {
    changeContent(item, i) {
      this.url = item.contentUrl;
      this.videoUrl = item.videoUrl;
      this.text = item.contentText;
      this.title = item.contentTitle;
      this.clearItem(i);

      document.getElementById(`item${i}`).style.borderTop =
        "solid 1px rgba(1,1,1, 1)";
      document.getElementById(`item${i}`).style.color = "rgba(0,0,0, 1)";

      if (null == this.videoUrl) {
        // 显示图片
        this.changeUrl();
      } else {
        // 显示视频
        this.changeVideoUrl();
      }
    },
    changeUrl() {
      let h = getBrowserHight(),w = getBrowserWidth(),videlH;
      // alert(w+'-'+h)
      document.getElementById(`videoWrap`).style.display = "none";
      // document.getElementById(`imgWrapper`).style.display = "block";
      this.isShowImg = true


      this.$nextTick(()=>{
        document.getElementById(`img`).style.backgroundImage = `url("${this.url}")`;
        let titleContH = document.getElementById(`titleCont`).offsetHeight
        let navcontainH = document.getElementById(`nav-wrap`).offsetHeight
        if (w <= 1300) {
          // 底部高度为 40  nav 62
          videlH = h - titleContH - navcontainH - 40;
        } else if (w > 1300 && w <= 1600) {
          // 底部高度为 50  nav 67
          videlH = h - titleContH - navcontainH - 50;
        } else if (w > 1600) {
          // 底部高度为 70  nav 87
          videlH = h - titleContH - navcontainH - 70;
        }
        document.getElementById(`imgWrapper`).style.height = `${videlH}px`;
      })
    },
    changeVideoUrl() {
      let h = getBrowserHight(),w = getBrowserWidth(),videlH;
      // alert(w+'-'+h)

      // document.getElementById(`imgWrapper`).style.display = "none";
      this.isShowImg = false
      document.getElementById(`videoWrap`).style.display = "block";
      document.getElementById(`video`).src = this.videoUrl;

      this.$nextTick(()=>{
        let titleContH = document.getElementById(`titleCont`).offsetHeight
        let navcontainH = document.getElementById(`nav-wrap`).offsetHeight

        if (w <= 1300) {
          // 底部高度为 40  nav 62
          videlH = h - titleContH - navcontainH - 40;
        } else if (w > 1300 && w <= 1600) {
          // 底部高度为 50  nav 67
          videlH = h - titleContH - navcontainH - 50;
        } else if (w > 1600) {
          // 底部高度为 70  nav 87
          videlH = h - titleContH - navcontainH - 70;
        }
        // alert(videlH)
        document.getElementById(`videoWrap`).style.height = `${videlH}px`;
      })
    },
    clearItem(i) {
      for (let index in this.subItem.content) {
        const item = this.subItem.content[index];
        const navTitle = item.navTitle;
        const len = getStringSize(navTitle);
        if (i != index) {
          document.getElementById(`item${index}`).style.borderTop = "";
          document.getElementById(`item${index}`).style.color =
            "rgba(153, 153, 153, 1)";
        }

        let w = getBrowserWidth();
        let wid = 90;
        if (w <= 1300) {
          wid = len * 7;
        } else if (w > 1300 && w <= 1600) {
          wid = len * 9;
        } else if (w > 1600) {
          wid = len * 10;
        }
        //document.getElementById(`item${index}`).style.width = `${wid}px`;
      }
    },
    makeData() {
      this.menuItem = this.menu[this.menuIndex];
      this.subItem = this.menuItem.subItem[this.itemIndex];
    },
    makeCss() {
      let total = 0;
      let w = getBrowserWidth();
      for (let index in this.subItem.content) {
        const item = this.subItem.content[index];
        const navTitle = item.navTitle;
        const len = getStringSize(navTitle);

        let wid = 90;
        if (w <= 1300) {
          wid = len * 7 + 20;
          total = total + wid;
        } else if (w > 1300 && w <= 1600) {
          wid = len * 9 + 20;
          total = total + wid;
        } else if (w > 1600) {
          wid = len * 10 + 40;
          total = total + wid;
        }
      }

      if (w <= 1300) {
        if (total >= 888) {
          total = total - 40;
        } else {
          total = total + 20;
        }
      } else if (w > 1300 && w <= 1600) {
      } else if (w > 1600) {
        if (total >= 1350) {
          total = total - 40;
        } else {
          total = total + 15;
        }
      }

    },
    setItemId(i) {
      let obj = `item${i}`;
      return obj;
    },
    updateData() {
      this.makeData();
      const item = this.subItem.content[0];
      this.makeCss();
      setTimeout(() => {
        this.changeContent(item, 0);
      }, 10);
    },
  },
};
</script>

<style scoped>

  .clickStyle {
    cursor: pointer;
  }
  .container {
    position: relative;
  }
  .section1 {
    position: relative;
    width: calc(100% - 480px);
    float: right;
  }
  .animate-route {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: fadeRoute;
  }
  @keyframes fadeRoute {
    from {
      opacity: 0.3;
    }
    to {
      opacity: 1;
    }
  }
  .section1 .imgWrapper {
    background: rgba(255, 255, 255, 0.7);
    overflow: hidden;
  }
  .contwrapper{
    display: flex;justify-content: center;align-items: center;
    width: 100%;
    height: 100%;
  }
  .section1 .img {
    background-image: url("https://www.csvw.com/u/cms/www/202008/03162427GbYU_700_410.jpg");
    background-position: center left;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    display: block;
    width: 100%;
    height: 100%;
  }
  .section1 .videoWrap {
    position: relative;
    width: 100%;
    background: rgba(255, 255, 255, 0.7);
    overflow: hidden;
  }
  .section1 .videoWrap .video {
    position: relative;
    /*width: 86%;*/
    /*margin: -50px auto 0;*/
    display: block;
    max-height: 100%;
    max-width: 100%;
  }
  .section1 .content {
    padding-top: 10px;
    padding-left: 60px;
    padding-right: 60px;
    background: rgba(255, 255, 255, 0.7);
    overflow: auto;
  }
  .section1 .content .title {
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }
  .section1 .content .text {
    font-size: 15px;
    line-height: 20px;
    color: rgba(0, 0, 0, 1);
  }
  .nav-wrap {
    width: 100%;
    border-top: solid 1px rgba(22, 22, 22, 0.1);
    background: rgba(255, 255, 255, 0.7);
    overflow-x: auto;
    display: flex;justify-content: center;
    padding-bottom: 20px;
  }
  .nav-contain {
    display: flex;flex-wrap: nowrap;
  }
  .nav-contain .item {
    margin-left: 20px;
    margin-right: 20px;
    color: rgba(153, 153, 153, 1);
    flex: none;
    padding-top: 10px;
  }
  .nav-contain .item .box {
    text-align: center;
    font-size: 16px;
  }

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .section1 {
    width: calc(100% - 330px);
  }
  .section1 .content {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .section1 .content .title {
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
  }
  .section1 .content .text {
    font-size: 10px;
    line-height: 14px;
  }
  .nav-contain .item .box {
    text-align: center;
    font-size: 12px;
  }
  .nav-wrap{
    padding-bottom: 4px;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .section1 {
    width: calc(100% - 480px);
  }
  .section1 .content {
    padding-top: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 10px;
  }
  .section1 .content .title {
    font-size: 15px;
    line-height: 23px;
  }
  .section1 .content .text {
    font-size: 14px;
    line-height: 20px;
  }
  .nav-contain .item .box {
    text-align: center;
    font-size: 14px;
  }
  .nav-wrap{
    padding-bottom: 10px;
  }
}
</style>